import React from 'react'

import Navigation from '../Navigation/Navigation'

import './Footer.css'

const Footer = ({ handleBurgerCLick }) => (
  <div className="fmbm-footer">
    <div className="fmbm-footer__contact">
      620 Davis St,<br />
      San Francisco, CA<br />
      94111 -{' '}
      <a href="/privacy" target="_new" rel="nofollow">
        Privacy Policy & Tos
      </a>
    </div>
    <Navigation handleBurgerCLick={handleBurgerCLick} />
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js